import { Box, TextField } from "@mui/material";
import { ButtonGroupSelector } from "features/WorklistTools/shared/components/ButtonGroupSelector";
import { CommaNumberInput } from "features/WorklistTools/shared/components/CommaNumberInput";
import { ApplyCellNumOption } from "features/WorklistTools/shared/interfaces";
import React, { useState } from "react";
import { DestPlateInfoState } from "../state";

interface WellMappingTableHeaderProps {
  handleApplyCellNumber: (
    option: string | number,
    cellNumber: number | undefined
  ) => void;
  destPlates: DestPlateInfoState[];
}
export const WellMappingTableHeader = ({
  handleApplyCellNumber, //where this come from
  destPlates,
}: WellMappingTableHeaderProps) => {
  const [transferVol, setTransferVol] = useState<number | undefined>();

  const additionalOptions: ApplyCellNumOption[] = destPlates
    .filter((destPlate) => destPlate.plateBarcode !== "")
    .map((destPlate) => ({
      label: destPlate.plateBarcode,
      value: destPlate.index,
    }));

  return (
    <React.Fragment>
      <Box sx={{ marginBottom: "5px" }}>
        <TextField
          value={transferVol ?? ""}
          onChange={(e) => setTransferVol(Number(e.target.value))}
          size="small"
          InputProps={{
            inputComponent: CommaNumberInput as any,
          }}
          label={"Transfer Vol"}
          sx={{ width: "150px" }}
        />
        <ButtonGroupSelector
          handleApplyCellNumber={handleApplyCellNumber}
          additionalOptions={additionalOptions}
          cellNumber={transferVol}
        />
      </Box>
    </React.Fragment>
  );
};
